var map = {
	"./cardHeaderBackgrounds/thumb_1.webp": 390,
	"./cardHeaderBackgrounds/thumb_10.webp": 399,
	"./cardHeaderBackgrounds/thumb_11.webp": 400,
	"./cardHeaderBackgrounds/thumb_12.webp": 401,
	"./cardHeaderBackgrounds/thumb_13.webp": 402,
	"./cardHeaderBackgrounds/thumb_14.webp": 403,
	"./cardHeaderBackgrounds/thumb_15.webp": 404,
	"./cardHeaderBackgrounds/thumb_16.webp": 405,
	"./cardHeaderBackgrounds/thumb_17.webp": 406,
	"./cardHeaderBackgrounds/thumb_18.webp": 817,
	"./cardHeaderBackgrounds/thumb_2.webp": 391,
	"./cardHeaderBackgrounds/thumb_3.webp": 392,
	"./cardHeaderBackgrounds/thumb_4.webp": 393,
	"./cardHeaderBackgrounds/thumb_5.webp": 394,
	"./cardHeaderBackgrounds/thumb_6.webp": 395,
	"./cardHeaderBackgrounds/thumb_7.webp": 396,
	"./cardHeaderBackgrounds/thumb_8.webp": 397,
	"./cardHeaderBackgrounds/thumb_9.webp": 398,
	"./connection-result-image.svg": 818,
	"./create-template-result.svg": 819,
	"./error-result-image.svg": 820,
	"./fork_page.svg": 821,
	"./invitation.png": 421,
	"./julian.svg": 822,
	"./julian_coffee.svg": 417,
	"./julian_jedi.svg": 422,
	"./julian_laptop.svg": 420,
	"./julian_sidepanel_empty.svg": 388,
	"./julian_sidepanel_pin.svg": 389,
	"./julian_step_1.svg": 423,
	"./julian_step_2.svg": 424,
	"./logo_julian.svg": 408,
	"./logo_julian_dark.svg": 409,
	"./logo_julian_notes_dark.svg": 823,
	"./logo_nigel.svg": 410,
	"./logo_nigel_dark.svg": 411,
	"./logo_sm.svg": 386,
	"./logo_sm_nigel.svg": 387,
	"./madeWithThunkNotes_darkmode.svg": 415,
	"./madeWithThunkNotes_lightmode.svg": 414,
	"./maintenance-result.svg": 824,
	"./masconts.svg": 825,
	"./mascots_love.svg": 425,
	"./mascots_success.svg": 272,
	"./nigel.svg": 826,
	"./nigel_nervous.svg": 418,
	"./nigel_nolook.svg": 419,
	"./nigel_serious.svg": 416,
	"./nigel_sidepanel_empty.svg": 407,
	"./note_copy.svg": 412,
	"./placeholder_text.svg": 827,
	"./placeholder_text_dark_mode.svg": 828,
	"./thumbnail_placeholder.svg": 413
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 816;